<template>
  <mds-notification-container v-if="notifications.length > 0">
    <mds-notification
      v-for="(notification, index) in notifications"
      :key="index + notification.notificationType"
      :variation="notification.notificationType"
      :title="notification.title"
      :tinted="notification.tinted"
      :dismissDelay="dismissDelayTime"
      @mds-notification-dismissed="removeNotification"
    >
      <template v-if="notification.message">{{ notification.message }}</template>
      <p v-if="errorMessage(notification.notificationType, notification.showContactInfo)">
        {{ errorMessage(notification.notificationType, notification.showContactInfo) }}
      </p>
      <template #mds-notification-custom-action v-if="notification.action">
        <button
            v-if="notification.action"
            class="mds-button mds-button--small mds-button--secondary mds-button__action-button"
            type="button"
            @click="browseTo(notification.action)"
          >
            {{ notification.actionLabel }}
          </button>
      </template>
    </mds-notification>
  </mds-notification-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { MdsNotification, MdsNotificationContainer } from '@mds/notification';

export default {
  name: 'Notification',
  components: {
    MdsNotification,
    MdsNotificationContainer,
  },
  data() {
    return {
      maxTime: 10,
    };
  },
  computed: {
    ...mapState({
      notifications: (state) => state.notification.settings.notifications,
    }),
    dismissDelayTime() {
      return this.maxTime * 1000;
    },
  },
  methods: {
    ...mapActions({
      closeNotification: 'closeNotification',
    }),
    browseTo(destination) {
      this.$router.push(`/${destination}`);
    },
    removeNotification() {
      this.closeNotification();
    },
    errorMessage(notificationType, showContactInfo) {
      // eslint-disable-next-line max-len
      if (notificationType === 'error' && showContactInfo) {
        return 'Try it later. If your error continues, email support@morningstar.com.';
      }
      return '';
    },
  },
};
</script>
